var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"btn-tooltip",attrs:{"disabled":true}},[_vm._v(" i ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }